import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Transition } from 'react-transition-group';
import { Button } from './Elements';
import Header from './Header';
import anime from 'animejs';
import Icon from '../static/Icons';
import createLogger from '../../utils/createLogger';

const DEBUG = false;
const debug = createLogger(DEBUG, `Modal.js`);

let modalContainer;

const animeProps = {
  duration: 500,
  easing: `easeInOutQuad`,
  delay: 100,
};

class Modal extends Component {

  static role = `modal`;
  static propTypes = {
    title: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    closeButton: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.state = {
      initialMount: false,
    }
  }

  componentDidMount() {
    modalContainer = document.getElementById(`modal-container`);
    this.setState({ initialMount: true });
  }

  componentWillUnmount() {

  }

  onEnter = (node) => {
    anime({
      targets: node,
      scale: [2, 1],
      opacity: [0, 1],
      ...animeProps,
    })
  };

  onExit = (node) => {
    anime({
      targets: node,
      scale: [1, 2],
      opacity: [1, 0],
      ...animeProps,
    })
  };

  renderChildren = () => {
    const {
      onEnter,
      onExit,
    }= this;
    const {
      title,
      close,
      isOpen,
      children,
      className,
      closeButton,
    } = this.props;

    debug.enter(`render`);
    debug.log(`modal: ${title} -- ${isOpen ? 'open' : 'closed'}`);

    const config = {
      className: classnames({
        'modal': true,
        [className]: !!className,
      }),
    };

    const tconfig = {
      in: isOpen,
      appear: false,
      timeout: animeProps.duration,
      onEnter,
      onExit,
    };

    return (
      <Transition {...tconfig}>
        {
          (state) => state !== `exited`
            ? (
              <div className="modal-overlay">
                <div {...config}>
                  <Header title={title} tier={3}>
                    {
                      closeButton ? (
                        <Button onClick={close} lowkey danger>
                          <Icon.Close/>
                        </Button>
                      ) : null
                    }
                  </Header>

                  { children }
                  </div>
              </div>
            ) : <div/>
        }
      </Transition>
    )
  };

  render() {
    const { renderChildren } = this;
    const { initialMount } = this.state;

    return initialMount
      ? ReactDOM.createPortal(renderChildren(),
        document.getElementById(`modal-container`))
      : null;
  }
}


class ModalContainer extends Component {

  componentDidMount() {
    modalContainer = document.getElementById(`modal-container`);
  }

  render() {
    return <div id="modal-container"/>
  }
}

export default Modal;
export {
  ModalContainer,
}



// WEBPACK FOOTER //
// ./src/components/static/Modal.js